/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ImportExamItemFilterViewModel } from "../types/ImportExamItemFilterViewModel.ts";

export const importExamItemFilterViewModelSchema = z.object({
  companyId: z.number().int().nullish(),
  cultureInfo: z.string().nullish(),
  authorId: z.number().int().nullish(),
  disciplineId: z.number().int().nullish(),
  componentType: z.number().int().nullish(),
  startDate: z.string().nullish(),
  endDate: z.string().nullish(),
  pageNumber: z.optional(z.number().int()),
  pageSize: z.optional(z.number().int()),
  sortField: z.string().nullish(),
  sortDirection: z.string().nullish(),
}) as unknown as ToZod<ImportExamItemFilterViewModel>;
